import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog, MatDialogConfig } from '@angular/material/dialog';
import { Router } from '@angular/router';
import { AngularEditorConfig } from '@kolkov/angular-editor';
import { CookieService } from 'ngx-cookie-service';
import { of } from 'rxjs';
import { catchError, map, switchMap } from 'rxjs/operators';
import { ChipsComponent } from 'src/app/shared/components/chips/chips.component';
import { ModalComponent } from 'src/app/shared/components/modal/modal.component';
import { AdminProfile, PsycologistProfile, TeacherProfile, UserProfile } from 'src/app/shared/models/profile.model';
import { environment } from 'src/environments/environment';
import { UserManagementService } from '../user-management/user-management.service';
import { ProfileService } from './profile.service';
import { BsDatepickerConfig } from 'ngx-bootstrap/datepicker';
import { GobalFunctionService } from 'src/app/core/services/gobal/gobal-function.service';
import { DatePipe } from 'src/app/shared/pipe/date.pipe';
import { ModalAvatarComponent } from './modal-avatar/modal-avatar.component';
import { Console } from 'console';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.component.html',
  styleUrls: ['./profile.component.scss']
})
export class ProfileComponent implements OnInit {
  @ViewChild(ChipsComponent) chips: ElementRef;
  userProfileForm: FormGroup;
  adminProfileForm: FormGroup;
  teacherProfileForm: FormGroup;
  psycologistProfileForm: FormGroup;

  userProfile: UserProfile = null;
  adminProfile: AdminProfile = null;
  teacherProfile: TeacherProfile = null;
  psycologistProfile: PsycologistProfile = null;
  editUserProfile = null;


  dialogConfig = new MatDialogConfig();
  confirmDialog;
  isEdit: boolean = false;
  isPremium: boolean = null;
  isLoading: boolean = true;
  isLoadingForUpdate: boolean = false;
  age: number;
  btnText: string = 'แก้ไข';
  btnCustom: string = 'color:white; background-color: #060E9F; padding: 0 50px;'
  date: Date = null;
  experties = [];
  selectedFile;
  errorMsg: string = null;
  role: string;
  teacherExperties = [];
  psychologistExperties = [];
  userProfilePic: string;

  editorConfig: AngularEditorConfig = {
    editable: true,
    spellcheck: true,
    height: 'auto',
    minHeight: '250px',
    maxHeight: 'auto',
    width: '100%',
    minWidth: '0',
    translate: 'yes',
    enableToolbar: true,
    showToolbar: true,
    placeholder: 'Enter text here...',
    defaultParagraphSeparator: '',
    defaultFontName: '',
    defaultFontSize: '',
    fonts: [
      { class: 'arial', name: 'Arial' },
      { class: 'times-new-roman', name: 'Times New Roman' },
      { class: 'calibri', name: 'Calibri' },
      { class: 'comic-sans-ms', name: 'Comic Sans MS' },
      { class: 'th-sarabun', name: 'Sarabun' },
      { class: 'K2D', name: 'K2D' },
    ],
    uploadUrl: environment.URL + '/manage_admin/uploadImgaeContentNews',
    uploadWithCredentials: false,
    sanitize: false,
    toolbarPosition: 'top'
  };

  constructor(
    public matDialog: MatDialog,
    private fb: FormBuilder,
    private router: Router,
    private profileService: ProfileService,
    private userManagementService: UserManagementService,
    private cookieService: CookieService,
    private bsDatepickerConfig: BsDatepickerConfig,
    private gbFunction: GobalFunctionService,
    private gobalFunctionService: GobalFunctionService
  ) {
    this.bsDatepickerConfig.dateInputFormat = 'D MMM YYYY';
  }

  ngOnInit(): void {
    this.profileService.getProfile().pipe(
      map(res => {
        let date;
        // // console.log(res);

        if (res.result.DATE_OF_BIRTH) {
          date = new Date(res.result.DATE_OF_BIRTH);
        }

        switch (res.result.ROLE) {
          case 'user': {
            this.userProfileForm = this.fb.group({
              username: [res.result.USERNAME, Validators.required],
              gender: [res.result.GENDER, Validators.required],
              dateOfBirth: [date, Validators.required],
              profilePic: ['']
            })
            break;
          }

          case 'teacher': {
            this.teacherProfileForm = this.fb.group({
              username: [res.result.USERNAME, Validators.required],
              gender: [res.result.GENDER, Validators.required],
              dateOfBirth: [date],
              phoneNO: [res.result.PHONENUMBER, Validators.pattern("(^02[0-9]{7}$)|(^06[0-9]{8}$)|(^08[0-9]{8}$)|(^09[0-9]{8}$)")],
              experties: ['', Validators.required],
              description: [res.result.PERSONAL_DESCRIPTION, Validators.required],
              profilePic: [res.result.PROFILE_PIC]
            })
            break;
          }

          case 'psychologist': {
            this.psycologistProfileForm = this.fb.group({
              username: [res.result.USERNAME, Validators.required],
              gender: [res.result.GENDER, Validators.required],
              dateOfBirth: [date],
              phoneNO: [res.result.PHONENUMBER, Validators.pattern("(^02[0-9]{7}$)|(^06[0-9]{8}$)|(^08[0-9]{8}$)|(^09[0-9]{8}$)")],
              experties: ['', Validators.required],
              description: [res.result.PERSONAL_DESCRIPTION, Validators.required],
              profilePic: ['']
            })
            break;
          }

          case 'admin': {
            this.adminProfileForm = this.fb.group({
              username: [res.result.USERNAME, Validators.required],
              gender: [res.result.GENDER, Validators.required],
              dateOfBirth: [date],
              phoneNO: [res.result.PHONENUMBER, Validators.pattern("(^02[0-9]{7}$)|(^06[0-9]{8}$)|(^08[0-9]{8}$)|(^09[0-9]{8}$)")],
              // description: ['', Validators.required],
              profilePic: ['']
            })
            break;
          }
        }

        this.gobalFunctionService.setTitle('โปรไฟล์');
        this.isEdit = false;
        this.setProfile(res);
      }),
      catchError((err) => {
        alert(err.error.message);
        return of(false)
      })
    ).subscribe()
  }

  toggleEdit(f?) {
    this.isEdit = !this.isEdit;
    this.errorMsg = null;
    if (this.isEdit) {
      this.btnText = 'ย้อนกลับ'
      this.btnCustom = 'color: white; background-color: #B8B8B8; padding: 0 50px;'
    } else {
      if (f) {
        // reset picture profile
        this.selectedFile = f.PROFILE_PIC;
        switch (f.ROLE) {
          case 'user': {
            this.editUserProfile = f.PROFILE_PIC;
            this.userProfileForm.controls['username'].setValue(f.USERNAME);
            this.userProfileForm.controls['gender'].setValue(f.GENDER);
            this.userProfileForm.controls['dateOfBirth'].setValue(f.DATE_OF_BIRTH ? new Date(f.DATE_OF_BIRTH) : '');
            break;
          }
          case 'teacher': {
            this.teacherProfile.EXPERTIES = this.teacherExperties
            this.teacherProfileForm.controls['username'].setValue(f.USERNAME);
            this.teacherProfileForm.controls['gender'].setValue(f.GENDER);
            this.teacherProfileForm.controls['dateOfBirth'].setValue(f.DATE_OF_BIRTH ? new Date(f.DATE_OF_BIRTH) : '');
            this.teacherProfileForm.controls['phoneNO'].setValue(f.PHONENUMBER);
            this.teacherProfileForm.controls['description'].setValue(f.PERSONAL_DESCRIPTION);
            break;
          }
          case 'psychologist': {
            this.psycologistProfile.EXPERTIES = this.psychologistExperties
            this.psycologistProfileForm.controls['username'].setValue(f.USERNAME);
            this.psycologistProfileForm.controls['gender'].setValue(f.GENDER);
            this.psycologistProfileForm.controls['dateOfBirth'].setValue(f.DATE_OF_BIRTH ? new Date(f.DATE_OF_BIRTH) : '');
            this.psycologistProfileForm.controls['phoneNO'].setValue(f.PHONENUMBER);
            this.psycologistProfileForm.controls['description'].setValue(f.PERSONAL_DESCRIPTION);
            break;
          }
          case 'admin': {
            this.adminProfileForm.controls['username'].setValue(f.USERNAME);
            this.adminProfileForm.controls['gender'].setValue(f.GENDER);
            this.adminProfileForm.controls['dateOfBirth'].setValue(f.DATE_OF_BIRTH ? new Date(f.DATE_OF_BIRTH) : '');
            this.adminProfileForm.controls['phoneNO'].setValue(f.PHONENUMBER);
            break;
          }
        }
      }
      this.btnText = 'แก้ไข'
      this.btnCustom = 'color: white; background-color: #060E9F; padding: 0 50px;'
    }
  }

  getExpertie() {
    this.profileService.getExpertie().subscribe(e => {
      this.experties = e.result;
    })
  }

  clickUpdate(profile) {
    this.isLoadingForUpdate = true;

    try {
      if (profile.get('experties')?.value === '') {
        if (this.teacherProfile) {
          profile.controls['experties'].setValue(JSON.stringify(this.teacherProfile.EXPERTIES));
        } else if (this.psycologistProfile) {
          profile.controls['experties'].setValue(JSON.stringify(this.psycologistProfile.EXPERTIES));
        }
      }
    } catch (error) {
      // console.log(error);
    }

    let date = new Date();

    if (date > profile.value.dateOfBirth) {
      this.profileService.updateProfile(profile.value).pipe(
        switchMap(res => {
          // // console.log(res);
          this.isLoadingForUpdate = false;
          this.errorMsg = null;
          this.dialogConfig.disableClose = true;
          this.dialogConfig.id = "modalConfirm";
          this.dialogConfig.width = '350px';

          this.dialogConfig.data = {
            title: "แก้ไขข้อมูลส่วนตัวเรียบร้อยแล้ว",
            description: '<img src="../../../assets/check.png" width="100px;" class="img-center">แก้ไขข้อมูลส่วนตัวเรียบร้อยแล้ว',
            cancleBtnText: "ตกลง",
          }
          this.confirmDialog = this.matDialog.open(ModalComponent, this.dialogConfig);
          return this.confirmDialog.afterClosed().pipe(
            switchMap(() => {
              return this.profileService.getProfile().pipe(
                map(r => {
                  this.setProfile(r);
                  location.reload();
                })
              )
            })
          )
        })
      ).subscribe(() => {
      }, err => {
        this.errorMsg = err.error.message;
        // // console.log(err);
        this.isLoadingForUpdate = false;
      })
    } else {
      alert('วันเกิดไม่ถูกต้อง กรุณาลองใหม่อีกครั้ง')
      this.isLoadingForUpdate = false;
    }
  }

  checkNumber(e) {
    var theEvent = e || window.event;

    // Handle paste
    if (theEvent.type === 'paste') {
      key = e.clipboardData.getData('text/plain');
    } else {
      // Handle key press
      var key = theEvent.keyCode || theEvent.which;
      key = String.fromCharCode(key);
    }
    var regex = /[0-9]|\./;
    if (!regex.test(key)) {
      theEvent.returnValue = false;
      if (theEvent.preventDefault) theEvent.preventDefault();
    }
  }

  getSelectedItem(e, profile) {
    // // console.log(e.listOfValue);
    // // console.log(profile);
    profile.controls['experties'].setValue(JSON.stringify(e.listOfValue));
  }

  compareFn(i1: any, i2: any): boolean {
    return i1 && i2 ? i1.EXPERTIE_ID === i2.EXPERTIE_ID : i1 === i2;
  }

  setProfile(p) {
    if (!p) return;
    // // console.log(p);

    switch (p.result.ROLE) {
      case 'user': {
        this.userProfile = p.result;
        this.userProfilePic = p.result.PROFILE_PIC;
        this.editUserProfile = p.result.PROFILE_PIC;
        break;
      }
      case 'teacher': {
        this.teacherProfile = p.result;
        this.selectedFile = p.result.PROFILE_PIC;
        this.teacherExperties = p.result.EXPERTIES;
        this.getExpertie();
        break;
      }
      case 'psychologist': {
        this.psycologistProfile = p.result;
        this.selectedFile = p.result.PROFILE_PIC;
        this.psychologistExperties = p.result.EXPERTIES;
        this.getExpertie();
        break;
      }
      case 'admin': {
        this.adminProfile = p.result;
        this.selectedFile = p.result.PROFILE_PIC;
        break;
      }
    }

    if (p.result.DATE_OF_BIRTH && p.result.DATE_OF_BIRTH !== '0000-00-00') {
      this.date = new Date(p.result.DATE_OF_BIRTH);
      this.age = this.calculateAge(this.date);
    }
    this.isLoading = false;
  }

  onFileSelected(e, profile) {
    const fileType = this.gbFunction.getTypeFile(e.target.files[0]);

    if (fileType === 'png' || fileType === 'jpg' || fileType === 'jpeg') {
      if (e.target.files && e.target.files[0]) {

        const file = (e.target as HTMLInputElement).files[0];
        profile.patchValue({
          profilePic: file
        });
        profile.get('profilePic').updateValueAndValidity()

        const reader = new FileReader();
        reader.readAsDataURL(e.target.files[0]);
        reader.onload = (event) => {
          var file = new File([reader.result], <any>reader.result);
          this.selectedFile = file.name;
        }
      }
    } else {
      alert('การอัปโหลดรูปภาพรองรับแค่ไฟล์ JPG, JPEG, PNG เท่านั้น กรุณาลองใหม่อีกครั้ง');
    }
  }

  calculateAge(birthday) {
    const today = new Date()
    const birthDate = new Date(birthday)
    let age = today.getFullYear() - birthDate.getFullYear();
    const m = today.getMonth() - birthDate.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
      age--;
    }
    return age;
  }

  deleteAccount(id, role) {
    const body = {
      ROLE: role,
      USER_ID: id,
      STATUS: 1
    }
    const dialogConfig = new MatDialogConfig();
    dialogConfig.disableClose = true;
    dialogConfig.id = "modalConfirm";
    dialogConfig.autoFocus = false;
    dialogConfig.data = {
      title: "ยืนยันการลบผู้ใช้งาน",
      description: "คุณต้องการลบแอคเคาท์ใช่หรือไม่?",
      actionBtnText: "ยืนยัน",
      cancleBtnText: "ยกเลิก",
      isDelete: true
    }
    let confirmModalDialog = this.matDialog.open(ModalComponent, dialogConfig);
    confirmModalDialog.afterClosed().pipe(
      switchMap(res => {
        if (res) {
          return this.userManagementService.updateStatusAccount(body).pipe(
            map(() => {
              this.cookieService.deleteAll();
              this.router.navigate(['/']);
            })
          )
        } else {
          return of(null);
        }
      })
    ).subscribe();
  }

  getEdit() {
    return this.isEdit;
  }

  selectAvatar() {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.disableClose = true;
    dialogConfig.id = 'modalConfirm';
    dialogConfig.width = '650px';
    dialogConfig.autoFocus = false;

    dialogConfig.data = {
      title: 'เปลี่ยนโปรไฟล์',
      actionBtnText: 'เสร็จสิ้น',
      isEdit: true,
    }

    const modal = this.matDialog.open(ModalAvatarComponent, dialogConfig);
    return modal.afterClosed().pipe(
      map(res => {
        if (!res.stautus) {
          // // console.log(res);
          this.userProfileForm.patchValue({
            profilePic: res.value.IMAGE_NAME
          });
          this.userProfileForm.get('profilePic').updateValueAndValidity();
          this.setProfilePic(res);
        }
        else {
          return of(null)
        }
      }),
      catchError(() => {
        return of(null);
      })
    ).subscribe();
  }

  setProfilePic(p) {
    // change profile pic when selected
    if (p.status) {
      this.editUserProfile = p.value.IMAGE_URL;
    } else {
      this.profileService.getProfile().pipe(
        map(res => {
          this.editUserProfile = res.result.PROFILE_PIC;
        })
      )
    }
  }
}
